import React from 'react';
import './styles.css';
import Button from '../Button';

const Section = ({ title, actions = [], children }) => {
  return (
    <section className="section">
      <div className={'section__header'}>
        {title && (
          <h2 className="section__title">{title}</h2>
        )}
        {actions && actions.map((action, index) => {
          return (
            <Button key={index} size={'s'} secondary icon={action.icon}>{action.label}</Button>
          );
        })}
      </div>
      {children}
    </section>
  );
};

export default Section;
